
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import moment from 'moment';
    import { confirmSwal, warningSwal } from '@/helper/swals';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import { SweetAlertResult } from 'sweetalert2';
    import { Teilimpfungsart } from '@/types/Teilimpfungsart';
    import { Verrechnungsart } from '@/types/Verrechnungsart';
    import Teilimpfungen from '@/types/Teilimpfungen';
    import Impfstoffe from '@/types/Impfstoffe';
    import Impfschema from '@/types/Impfschema';
    import ElgaImpfstoffe from '@/types/ElgaImpfstoffe';
    import Charge from '@/types/Charge';
    import Impfung from '@/types/Impfung';
    import ImmunizationTarget from '@/types/ImmunizationTarget';
    import { LastImpfung, ValidationRules } from '@/store/types';
    import { VAutocomplete, VForm, VTextField } from '@/types/Components';
    import Patient from '@/types/Patient';
    import { ImpfstoffeSelect } from '@/store/impfstoff';
    import { LoadPersonenPayload } from '@/store/personen';
    import _ from 'lodash';
    import {SystemEinstellung, SystemEinstellungKey} from '@/types/Einstellung';
    import {Patgruppe} from '@/types/Patgruppe';
    import {NotificationInterface} from '@/services/Response';
    import Impfaktion from '@/types/Impfaktion';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules', 'formatDate', 'parseDate']),
            ...mapState('impfaktionen', ['impfaktionen']),
            ...mapState('impfaktionen', { impfaktionenLoaders: 'loaders'}),
            ...mapState('studien', ['studien']),
            ...mapState('studien', { studienLoaders: 'loaders'}),
            ...mapState('session', ['arzt', 'assistenz', 'lastImpfung', 'lastNachtrag', 'abrechnung']),
            ...mapState('authentication', ['impfstelle_id']),
            ...mapState('patient', ['loaders', 'patientData']),
            ...mapState('impfstoff', [
                'impfstoffe',
                'chargen',
                'teilimpfungen',
                'indikation',
                'impfschema',
                'relevanteErkrankungen',
                'specialSituationIndication',
                'elgaimpfstoffe',
                'immunizationtarget',
            ]),
            ...mapGetters('personen', ['getPersonen', 'getAssistenten']),
            ...mapState('personen', { personenLoaders: 'loaders' }),
            ...mapGetters('impfsettings', ['getImpfsettings']),
            ...mapState('impfsettings', { impfsettingsLoaders: 'loaders' }),
            ...mapState('impfstoff', { loadersImpfstoff: 'loaders' }),
            ...mapGetters('authentication', ['isAllowed', 'getSystemEinstellung']),
        },
        methods: {
            ...mapActions('impfstoff', ['loadImpfstoffe']),
            ...mapActions('impfsettings', ['loadImpfsettings']),
            ...mapActions('personen', ['loadPersonen']),
            ...mapActions('patient', [
                'createImpfung',
                'createImpfungUndNeu',
                'deleteImpfung',
                'editImpfung',
                'loadImpfungen',
                'impfungUebertragen',
                'impfungStornieren',
                'setSelectedOffenNext',
                'updateImpferinnerung',
                'resetErinnerungGesendet',
                'updateImpfungAbrechnung',
                'loadErinnerungen',
            ]),
            ...mapActions('session', [
                'setSelectedArzt',
                'setSelectedAssistenz',
                'setLastImpfung',
                'setSelectedAbrechnung',
            ]),
            ...mapActions('impfaktionen', ['loadImpfaktionen']),
            ...mapActions('studien', ['loadStudien']),
        },
    })
    export default class ImpfungDetail extends Vue {
        @Prop() title!: string;
        @Prop() visible!: boolean;
        @Prop() value!: Impfung;
        @Prop() isNew!: boolean;
        @Prop() isNachtrag!: boolean;

        public $refs!: {
            form: VForm;
            impfstoffcharge_id: VAutocomplete;
            impfschema_code: VAutocomplete;
            teilimpfungsnr: VAutocomplete;
            naechsteteilimpfungsnr: VAutocomplete;
            anzahl: VTextField;
            person_id_helfer: VAutocomplete;
            impfstoff_id: VAutocomplete
        };

        public rules!: ValidationRules;
        public parseDate!: (input: string | null) => string | null;
        public formatDate!: (input: string | null) => string | null;
        public impfstoffe!: Impfstoffe[];
        public elgaimpfstoffe!: ElgaImpfstoffe[];
        public immunizationtarget!: ImmunizationTarget[];
        public lastImpfung!: LastImpfung | null;
        public lastNachtrag!: LastImpfung | null;
        public abrechnung!: Verrechnungsart | null;
        public patientData!: Patient;
        public impfstelle_id!: number;
        public arzt!: number | null;
        public assistenz!: number | null;
        public loadImpfstoffe!: (payload: ImpfstoffeSelect) => void;
        public loadImpfsettings!: () => void;
        public loadPersonen!: (payload?: LoadPersonenPayload) => void;
        public loadImpfungen!: () => void;
        public loadImpfaktionen!: () => void;
        public loadStudien!: () => void;
        public setLastImpfung!: (payload: { impfung: LastImpfung | null, nachtrag: boolean }) => void;
        public chargen!: Charge[];
        public teilimpfungen!: Teilimpfungen[];
        public relevanteErkrankungen!: () => void;
        public specialSituationIndication!: () => void;
        public impfungStornieren!: (payload: { patimpfung_id: number; impfstelle_id: number }) => void;
        public impfungUebertragen!: (payload: { patimpfung_id: number; impfstelle_id: number }) => void;
        public createImpfung!: (payload: Impfung) => void;
        public deleteImpfung!: () => void;
        public editImpfung!: (payload: Impfung) => Promise<boolean>;
        public setSelectedOffenNext!: () => void;
        public updateImpferinnerung!: (payload: Impfung) => void;
        public resetErinnerungGesendet!: (payload: Impfung) => void;
        public updateImpfungAbrechnung!: (payload: any) => void;
        public loadErinnerungen!: () => void;
        public setSelectedAbrechnung!: (payload: Verrechnungsart) => void;
        public createImpfungUndNeu!: (payload: { impfung: Impfung, nachtrag: boolean }) => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;
        public impfaktionen: any;

        public fremdimpfunginfos = [
            {key: 'I', value: 'Impfpass'},
            {key: 'K', value: 'Kooperationspartner'},
            {key: 'P', value: 'Patient'}
        ];

        public keineVerrechnung = Verrechnungsart.NichtVerrechenbar;
        public mitVerrechnung = Verrechnungsart.Offen;

        public data = new Impfung();
        public barcode = '';
        public reloadImpfungen = false;
        public merken = false;
        public isEditing = false;
        public auffrischungEingerichtet = true;

        public impfdatumMenu = false;
        public impfdatumFormatted: string | null = null;
        public impfdatumErrorMessages: string[] = [];

        public naechstesImpfdatumMenu = false;
        public naechstesImpfdatumFormatted: string | null = null;
        public naechstesImpfdatumErrorMessages: string[] = [];

        public get chargeAblaufdatum(): string | null {
            return this.data.impfstoffcharge_ablaufdatum ?? this.impfstoffChargen.find((charge: Charge) => {
                return charge.impfstoffcharge_id === this.data.impfstoffcharge_id;
            })?.ablaufdatum ?? null;
        }

        public get isNaechstesImpfdatumRequired(): boolean {
            return !this.data.isEinfachimpfung && this.data.teilimpfungsnr !== null && this.auffrischungEingerichtet;
        }

        public get naechstesImpfdatumLabel(): string {
            return 'Nächstes Impfdatum' + (this.isNaechstesImpfdatumRequired ? '*' : '');
        }

        public get impfsettingDisplay(): string {
            return `${this.data.impfsetting_setting_code ?? ''} ${this.data.impfsetting_displayname ?? ''}`.trim();
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
                this.barcode = '';
                this.isEditing = false;

                this.data = new Impfung(this.value);

                if (this.isNew) {
                    if (this.$refs.impfstoff_id) {
                        this.$refs.impfstoff_id.focus();
                    }

                    if (!this.isNachtrag) {
                        this.data.impfdatum = moment().format('YYYY-MM-DD');
                        this.data.lagerbuchung = 'j';
                        this.data.abrechnung = Verrechnungsart.Offen;
                        this.data.nachtrag = 'n';
                        this.data.aufklaerung_nebenwirkungen = 'j';
                    } else {
                        this.data.nachtrag = 'j';
                        this.data.fremdimpfung = 'j';
                        this.data.fremdimpfungsinfo = 'I';
                        this.data.lagerbuchung = 'n';
                        this.data.abrechnung = Verrechnungsart.NichtVerrechenbar;
                    }

                    this.data.patnr = this.patientData.patnr;
                    this.data.anzahl = 1;
                    this.data.impfstelle_id = this.impfstelle_id;
                    this.data.person_id_durchf = this.arzt;
                    this.data.person_id_helfer = this.assistenz;
                    this.data.patientengruppe_id = this.patientData.patientengruppe_id;
                    this.data.impfsetting_setting_code = this.getSystemEinstellung<string>('default_impfsetting').value ?? null;

                    this.loadImpfstoffe({
                        chargen: true,
                        elgaimpfstoffe: true,
                        immunziationTarget: true,
                        impfschemen: true,
                        teilimpfungen: true,
                        nachtrag: this.isNachtrag,
                    });
                    this.loadPersonen();
                    this.loadImpfsettings();
                } else {
                    this.data.impfdatum = moment(this.data.impfdatum).format('YYYY-MM-DD');
                }

                if (this.data.patplan_id) {
                    this.onChangeImpfstoff();
                    this.onChangeTeilimpfungsnr();
                }
                this.impfdatumErrorMessages = [];
                this.naechstesImpfdatumErrorMessages = [];
                this.impfdatumFormatted = this.formatDate(this.data.impfdatum);
                this.naechstesImpfdatumFormatted = this.formatDate(this.data.naechstesimpfdatum);
                if (this.getSystemEinstellung('muw').isEnabled()) {
                    this.loadImpfaktionen();
                    this.loadStudien();
                }
            } else {
                if (this.reloadImpfungen) {
                    this.reloadImpfungen = false;
                    if (this.getSystemEinstellung('muw').isEnabled()) {
                        this.loadImpfungen();
                        this.loadErinnerungen();
                    }
                }

                if (this.isNew && !this.data.patplan_id) {
                    const impfung = this.merken
                        ? {
                            impfstoff_id: this.data.impfstoff_id,
                            impfstoffcharge_id: this.data.impfstoffcharge_id,
                            impfschema_code: this.data.impfschema_code,
                            anzahl: this.data.anzahl,
                            teilimpfungsnr: this.data.teilimpfungsnr,
                            naechsteteilimpfungsnr: this.data.naechsteteilimpfungsnr,
                            impfdatum: this.impfdatumErrorMessages.length === 0
                                ? this.data.impfdatum
                                : null,
                            naechstesimpfdatum: this.naechstesImpfdatumErrorMessages.length === 0
                                ? this.data.naechstesimpfdatum
                                : null,
                        } : null;

                    this.setLastImpfung({impfung, nachtrag: this.isNachtrag});
                }

                if (this.data.patplan_id) {
                    setTimeout(() => this.setSelectedOffenNext(), 100);
                }
            }
        }

        @Watch('loadersImpfstoff.impfstoffe')
        public onChangeLoadingImpfstoffe(isLoading: boolean): void {
            if (!isLoading && !this.data.patplan_id) {
                const lastData = this.isNachtrag ? this.lastNachtrag : this.lastImpfung;
                this.merken = lastData !== null;

                if (this.merken) {
                    this.restoreImpfung(lastData as LastImpfung);
                }
            }
        }

        public get impfstoff(): Impfstoffe | undefined {
            return this.impfstoffe.find((impfstoff: Impfstoffe) => {
                return impfstoff.impfstoff_id === this.data.impfstoff_id;
            });
        }

        public get impfstoffBezeichnung(): string {
            return (this.isNew ? this.impfstoff?.bezeichnung : this.data.bezeichnung) ?? '';
        }

        public get impfstoffAnmerkung(): string {
            return this.impfstoff?.anmerkung ?? '';
        }

        public get isImpfungAuffrischung(): boolean {
            return this.data.teilimpfungsnr === Teilimpfungsart.Auffrischung;
        }

        public get isImpfungEinfachimpfung(): boolean {
            return this.data.teilimpfungsnr === Teilimpfungsart.Einfachimpfung;
        }

        public get isNaechsteImpfungAuffrischung(): boolean {
            return this.data.naechsteteilimpfungsnr === Teilimpfungsart.Auffrischung;
        }

        public get isNaechsteImpfungEinfachimpfung(): boolean {
            return this.data.naechsteteilimpfungsnr === Teilimpfungsart.Einfachimpfung;
        }

        public get maxZeitraum(): string {
            return moment().format('YYYY-MM-DD');
        }

        public get immunizationTarget(): string {
            if (this.impfstoff?.impfung) {
                return this.impfstoff.impfung;
            }
            if (!this.isNew) {
                return this.data.immunization_displayname ?? '';
            }

            const impfstoff_code = this.impfstoff?.impfstoff_code;
            if (!impfstoff_code) return '';

            const elgaimpfstoff = this.elgaimpfstoffe.find((impfstoff) => impfstoff.impfstoff_code === impfstoff_code);
            if (!elgaimpfstoff) return '';

            const code = elgaimpfstoff.elga_impfungindikation_k_code || elgaimpfstoff.elga_impfungindikation_01_code;
            const target = this.immunizationtarget.find((immunization) => immunization.impfungindikation_code === code);

            return target?.displayname ?? '';
        }

        public get hasTeilimpfungen(): boolean {
            return this.filteredTeilimpfungen.some((teilimpfung: Teilimpfungen) => {
                return !teilimpfung.isAuffrischung && !teilimpfung.isEinfachimpfung;
            });
        }

        @Watch('data.teilimpfungsnr', {immediate: true})
        public onChangeTeilimpfungsnr(): void {
            this.auffrischungEingerichtet = true;

            if (!this.isNew && !this.data.isNachtrag) {
                return;
            }

            const teilimpfungen = this.filteredTeilimpfungen;
            const teilimpfungsnr = this.data.teilimpfungsnr;

            const teilimpfung = teilimpfungen.find((teilimpfung: Teilimpfungen) => {
                return teilimpfung.teilimpfungsnr === teilimpfungsnr;
            });

            const calcNextImpfdatum = (nextTeilimpfung: Teilimpfungen, prevTeilimpfung?: Teilimpfungen):
                string | null => {
                if (nextTeilimpfung.isAuffrischung && !nextTeilimpfung.teilimpfung_id) {
                    this.auffrischungEingerichtet = false;
                    return null;
                }

                const teilimpfung = prevTeilimpfung ?? nextTeilimpfung;

                const abAlter = nextTeilimpfung.abstand2_alter ?? 0;
                const patientAlter = this.patientData.alter; // TODO: Alter durch Impfdatum berechnen

                if (nextTeilimpfung.teilimpfungsnr === Teilimpfungsart.Auffrischung &&
                    abAlter > 0 &&
                    typeof patientAlter === 'number' &&
                    patientAlter >= abAlter) {
                    return moment(this.data.impfdatum)
                        .add(nextTeilimpfung.abstand2_tage ?? 0, 'days')
                        .add(nextTeilimpfung.abstand2_wochen ?? 0, 'weeks')
                        .add(nextTeilimpfung.abstand2_monate ?? 0, 'months')
                        .add(nextTeilimpfung.abstand2_jahre ?? 0, 'years')
                        .format('YYYY-MM-DD');
                } else {
                    return moment(this.data.impfdatum)
                        .add(teilimpfung.abstand_tage ?? 0, 'days')
                        .add(teilimpfung.abstand_wochen ?? 0, 'weeks')
                        .add(teilimpfung.abstand_monate ?? 0, 'months')
                        .add(teilimpfung.abstand_jahre ?? 0, 'years')
                        .format('YYYY-MM-DD');
                }
            };

            const checkAuffrischung = (): void => {
                const auffrischung = teilimpfungen.find(({teilimpfungsnr}: Teilimpfungen) => {
                    return teilimpfungsnr === Teilimpfungsart.Auffrischung;
                });

                if (auffrischung) {
                    this.data.naechsteteilimpfungsnr = Teilimpfungsart.Auffrischung;
                    this.data.naechstesimpfdatum = calcNextImpfdatum(auffrischung);
                    this.data.impferinnerung = auffrischung.impferinnerung ?? this.impfstoff?.impferinnerung ?? 'n';
                } else {
                    this.data.naechsteteilimpfungsnr = null;
                    this.data.naechstesimpfdatum = null;
                }
            };

            if (!teilimpfung || teilimpfung.isEinfachimpfung) {
                return checkAuffrischung();
            }

            const nextTeilimpfung = teilimpfungen.find(({teilimpfungsnr}: Teilimpfungen) => {
                return teilimpfungsnr === (teilimpfung.teilimpfungsnr ?? 0) + 1;
            }) ?? teilimpfungen.find(({teilimpfungsnr}: Teilimpfungen) => {
                return teilimpfungsnr === Teilimpfungsart.Auffrischung;
            });

            if (nextTeilimpfung) {
                this.data.impferinnerung = teilimpfung.impferinnerung ?? this.impfstoff?.impferinnerung ?? 'n';

                if (this.impfdatumErrorMessages.length !== 0) {
                    return;
                }

                this.data.naechsteteilimpfungsnr = nextTeilimpfung.teilimpfungsnr;
                this.data.naechstesimpfdatum = calcNextImpfdatum(nextTeilimpfung, teilimpfung);
            } else {
                checkAuffrischung();
            }
        }

        @Watch('data.naechsteteilimpfungsnr')
        public onChangeNaechsteteilimpfungsnr(naechsteteilimpfungsnr: string | null): void {
            if (naechsteteilimpfungsnr === null) {
                this.data.naechstesimpfdatum = null;

                // TODO
                /*if (this.$refs.naechstesimpfdatum) {
                    (this.$refs.naechstesimpfdatum as any).reset();
                }*/
            }
        }

        public get impfstoffChargen(): Charge[] {
            const availableChargen = (charge: Charge): boolean => {
                return charge.impfstoff_id === this.data.impfstoff_id && (charge.lagerbestand ?? 0) > 0;
            };

            type ChargeRow = Charge & { fw_created: string | null };

            const byAblaufdatumEingangsdatumEintragsdatumImpfstoffId = (a: Charge, b: Charge): number => {
                const ablaufdatumComparison = (a.ablaufdatum ?? '').localeCompare(b.ablaufdatum ?? '');
                if (ablaufdatumComparison !== 0) {
                    return ablaufdatumComparison;
                }

                const eingangsdatumComparison = (a.eingangsdatum ?? '').localeCompare(b.eingangsdatum ?? '');
                if (eingangsdatumComparison !== 0) {
                    return eingangsdatumComparison;
                }

                const eintragsdatumComparison = ((a as ChargeRow).fw_created ?? '')
                    .localeCompare((b as ChargeRow).fw_created ?? '');

                if (eintragsdatumComparison !== 0) {
                    return eintragsdatumComparison;
                }

                const impfstoffIdA = a.impfstoff_id as number;
                const impfstoffIdB = b.impfstoff_id as number;

                return impfstoffIdB - impfstoffIdA;
            };

            var retval: Charge [] = [];
            var chargeNRs: any [] = [];

            var chargen = this.chargen
                .filter(availableChargen)
                .sort(byAblaufdatumEingangsdatumEintragsdatumImpfstoffId);

            if (chargen.length > 0) {
                retval = [];
                chargeNRs = [];

                _.forEach(chargen, (item: Charge, index) => {
                    if (index === 0) {
                        retval.push(item);
                        chargeNRs.push(item.chargennr);
                    } else {
                        if (item.chargennr) {
                            if (!chargeNRs.includes(item.chargennr)) {
                                retval.push(item);
                                chargeNRs.push(item.chargennr);
                            }
                        }
                    }
                });
            } else {
                retval = chargen;
            }
            return retval;
        }

        public get impfschemen(): Impfschema[] {
            const impfstoff = this.impfstoff;

            if (!impfstoff || !impfstoff.impfstoff_code) {
                return [];
            }

            const impfschemen = this.elgaimpfstoffe
                .find(({impfstoff_code}) => impfstoff_code === impfstoff.impfstoff_code)?.impfschemen ?? [];

            const teilimpfungen = this.teilimpfungen
                .filter(({impfstoff_id}) => impfstoff_id === impfstoff.impfstoff_id);

            return impfschemen.filter((impfschema) => {
                return teilimpfungen.some(({impfschema_code}) => impfschema_code === impfschema.impfschema_code);
            });
        }

        @Watch('data.impfdatum')
        public onChangeImpfdatum(date: string | null): void {
            this.impfdatumFormatted = this.formatDate(this.data.impfdatum);

            if (date !== null) {
                this.validateImpfdatum();
                this.onChangeTeilimpfungsnr();
            }
        }

        @Watch('data.naechstesimpfdatum')
        public onChangeNaechstesImpfdatum(date: string | null): void {
            if (this.data.impfdatum && this.impfdatumErrorMessages.length === 0) {
                this.$nextTick(() => {
                    this.naechstesImpfdatumFormatted = this.formatDate(this.data.naechstesimpfdatum);

                    if (date !== null) {
                        this.validateNaechstesImpfdatum();
                    }
                });
            }
        }

        public onBlurImpfdatum(): void {
            this.data.impfdatum = this.parseDate(this.impfdatumFormatted);
            this.$nextTick(() => this.onChangeTeilimpfungsnr());
        }

        public validateImpfdatum(): void {
            this.impfdatumErrorMessages = [];

            if (!this.isNew) {
                return;
            }

            for (const rule of [this.rules.required, this.rules.validDate]) {
                const valid = rule(this.data.impfdatum);
                if (valid !== true) {
                    this.impfdatumErrorMessages.push(valid as string);
                }
            }

            if (this.data.impfdatum && (this.data.impfdatum > moment().format('YYYY-MM-DD'))) {
                this.impfdatumErrorMessages.push('Impfdatum darf nicht in der Zukunft sein.');
            }
        }

        public validateNaechstesImpfdatum(): void {
            this.naechstesImpfdatumErrorMessages = [];

            if (!this.isNew ||
                !this.data.impfdatum ||
                this.impfdatumErrorMessages.length > 0) {
                return;
            }

            const rules = [];

            if (this.isNaechstesImpfdatumRequired) {
                rules.push(this.rules.required);
            }

            if (this.data.naechstesimpfdatum) {
                rules.push(this.rules.validDate);
            }

            for (const rule of rules) {
                const valid = rule(this.data.naechstesimpfdatum);

                if (valid !== true) {
                    this.naechstesImpfdatumErrorMessages.push(valid as string);
                }
            }
        }

        public get filteredTeilimpfungen(): Teilimpfungen[] {
            let teilimpfungen = this.teilimpfungen.filter((teilimpfung: Teilimpfungen) => {
                return teilimpfung.impfstoff_id === this.data.impfstoff_id &&
                    teilimpfung.impfschema_code === this.data.impfschema_code;
            });

            if (teilimpfungen.length === 0) {
                teilimpfungen = this.teilimpfungen.filter((teilimpfung: Teilimpfungen) => {
                    return teilimpfung.impfstoff_id === this.data.impfstoff_id &&
                        teilimpfung.impfschema_code === null;
                });
            }

            if (teilimpfungen.length === 0) {
                teilimpfungen.push(new Teilimpfungen(Teilimpfungsart.Einfachimpfung));
            }

            const auffrischung = teilimpfungen.some(({teilimpfungsnr}: Teilimpfungen) => {
                return teilimpfungsnr === Teilimpfungsart.Auffrischung;
            });

            if (!auffrischung) {
                teilimpfungen.push(new Teilimpfungen(Teilimpfungsart.Auffrischung));
            }

            return teilimpfungen;
        }

        public onChangeImpfstoff(): void {
            if (!this.data.patplan_id && this.isNew) {
                for (const ref of [
            this.$refs.impfstoffcharge_id,
            this.$refs.impfschema_code,
            this.$refs.teilimpfungsnr,
            this.$refs.naechsteteilimpfungsnr,
                ]) {
                    if (ref) {
                        ref.reset();
                    }
                }

                //this.onChangeImpfschema();

                this.data.impfschema_code = null;
                this.data.teilimpfungsnr = null;
                this.data.naechsteteilimpfungsnr = null;
                this.data.naechstesimpfdatum = null;
            }

            const impfstoff = this.impfstoff;
            if (this.isNew) {
                this.data.impferinnerung = impfstoff?.impferinnerung ?? 'n';
            }

            if (!this.isNachtrag) {
                this.data.abrechnung = (impfstoff?.verkaufspreis ?? 0) > 0 ? Verrechnungsart.Offen : Verrechnungsart.NichtVerrechenbar;
            }

            const chargen = this.impfstoffChargen;
            if (chargen.length === 1) {
                const [charge] = chargen;
                this.data.impfstoffcharge_id = charge.impfstoffcharge_id;
            }

            const impfschemen = this.impfschemen;
            if (impfschemen.length === 1) {
                const [impfschema] = impfschemen;
                this.data.impfschema_code = impfschema.impfschema_code;
            }

            this.data.impfstoff_code = this.impfstoff?.impfstoff_code ?? null;
            this.isHCWEnabled();
        }

        public onChangeBarcode(): void {
            this.data.impfstoff_id = this.impfstoffe.find((impfstoff: Impfstoffe) => {
                return impfstoff.barcode === this.barcode;
            })?.impfstoff_id ?? null;
        }

        public restoreImpfung(data: LastImpfung): void {
            const impfstoffById = (impfstoff: Impfstoffe): boolean => impfstoff.impfstoff_id === data.impfstoff_id;
            const chargeById = (charge: Charge): boolean => charge.impfstoffcharge_id === data.impfstoffcharge_id;
            const impschemaById = (schema: Impfschema): boolean => schema.impfschema_code === data.impfschema_code;
            const teilimpfung = (teilimpfungsnr: number): (teilimpfung: Teilimpfungen) => boolean => {
                return (teilimpfung: Teilimpfungen): boolean => teilimpfung.teilimpfungsnr === teilimpfungsnr;
            };

            if (this.impfstoffe.find(impfstoffById)) {
                this.data.impfstoff_id = data.impfstoff_id;

                if (this.impfstoffChargen.some(chargeById)) {
                    this.data.impfstoffcharge_id = data.impfstoffcharge_id;
                }

                if (this.impfschemen.some(impschemaById)) {
                    this.data.impfschema_code = data.impfschema_code;
                }

                const teilimpfungen = this.filteredTeilimpfungen;

                if (data.teilimpfungsnr !== null && teilimpfungen.some(teilimpfung(data.teilimpfungsnr))) {
                    this.data.teilimpfungsnr = data.teilimpfungsnr;
                }

                if (data.naechsteteilimpfungsnr !== null &&
                    teilimpfungen.some(teilimpfung(data.naechsteteilimpfungsnr))) {
                    this.data.naechsteteilimpfungsnr = data.naechsteteilimpfungsnr;
                }
            }

            this.data.anzahl = data.anzahl;
            this.data.impfdatum = data.impfdatum
                ? this.parseDate(data.impfdatum)
                : null;
            this.data.naechstesimpfdatum = data.naechstesimpfdatum
                ? this.parseDate(data.naechstesimpfdatum)
                : null;
        }

        public onChangeImpferinnerung(): void {
            if (this.getSystemEinstellung('muw').isEnabled() || this.data.isNachtrag) {
                return;
            }
            this.updateImpferinnerung(this.data);
            this.reloadImpfungen = true;
        }

        public onClickResetErinnerungGesendet(): void {
            this.resetErinnerungGesendet(this.data);
            this.reloadImpfungen = true;
        }

        public onChangeAbrechnung(): void {
            if (this.getSystemEinstellung('muw').isEnabled()) {
                return;
            }

            this.setSelectedAbrechnung(this.data.abrechnung ?? Verrechnungsart.NichtVerrechenbar);

            if (!this.isNew) {
                this.updateImpfungAbrechnung({
                    patimpfung_id: this.data.patimpfung_id,
                    abrechnung: this.data.abrechnung ?? Verrechnungsart.NichtVerrechenbar,
                    hcw: this.data.hcw
                });
                this.reloadImpfungen = true;
            }
        }

        @Watch('value.impferinnerung')
        public onChangeValueImpferinnerung(): void {
            if (this.visible) {
                this.data.impferinnerung = this.value.impferinnerung;
                this.updateModifiedFiels();
            }
        }

        @Watch('value.erinnerung_gesendet')
        public onChangeValueErinnerungGesendet(): void {
            if (this.visible) {
                this.data.erinnerung_gesendet = this.value.erinnerung_gesendet;
                this.updateModifiedFiels();
            }
        }

        @Watch('value.abrechnung')
        public onChangeValueAbrechnung(): void {
            if (this.visible) {
                this.data.abrechnung = this.value.abrechnung;
                this.updateModifiedFiels();
            }
        }

        public updateModifiedFiels(): void {
            type TableRow = Impfung & { fw_modified: string | null; fw_modified_by: number | null };

            const data = this.data as TableRow;
            const value = this.value as TableRow;

            data.fw_modified = value.fw_modified;
            data.fw_modified_by = value.fw_modified_by;
        }

        public onClickUebertragenStornieren(): void {
            const request = (): void => {
                const patimpfung_id = this.data.patimpfung_id as number;
                const impfstelle_id = this.impfstelle_id;

                const action = this.data.eimpf_id !== null
                    ? this.impfungStornieren
                    : this.impfungUebertragen;

                action({patimpfung_id, impfstelle_id});
                this.$emit('close');
            };

            if (this.data.isInStornierung || this.data.isInTransfer) {
                const [status, aktion, confirmText] = this.data.isInStornierung
                    ? ['storniert', 'Stornierung', 'Stornieren']
                    : ['übertragen', 'Übertragung', 'Übertragen'];

                confirmSwal(
                    'e-Impfpass',
                    `Diese Impfung wird zurzeit ${status}. Wollen Sie eine neue ${aktion} beantragen?`,
                    confirmText,
                    'Abbrechen',
                ).then(({isConfirmed}) => {
                    if (isConfirmed) {
                        request();
                    } else {
                        this.reloadImpfungen = true;
                    }
                });
            } else {
                request();
            }
        }

        public onClickSave(): void {
            this.validateImpfdatum();
            this.validateNaechstesImpfdatum();

            if (!this.$refs.form.validate() ||
                this.impfdatumErrorMessages.length > 0 ||
                this.naechstesImpfdatumErrorMessages.length > 0) {
                return;
            }

            const impfung = Object.assign(
                new Impfung(),
                {
                    ...this.data,
                    impfdatum: this.parseDate(this.impfdatumFormatted),
                    naechstesimpfdatum: this.parseDate(this.naechstesImpfdatumFormatted),
                },
            );

            if (this.isEditing) {
                const elgaUpdateFields: (keyof Impfung)[] = [
                    'teilimpfungsnr',
                    'impfdatum',
                    'impfschema_code',
                    'impfsetting_setting_code',
                ];

                const elgaImpfpassAenderungen = elgaUpdateFields.filter((field) => {
                    return impfung[field] !== this.value[field];
                });

                const afterEdit = (success: boolean): void => {
                    if (success) {
                        this.reloadImpfungen = true;
                    }
                    this.isEditing = !success;
                };

                if (elgaImpfpassAenderungen.length > 0) {
                    const en = elgaImpfpassAenderungen.length === 1 ? '' : 'en';
                    const diesen = elgaImpfpassAenderungen.length === 1 ? 'dieser' : 'diesen';

                    confirmSwal(
                        'Impfung bearbeiten',
                        `Mit ${diesen} Änderung${en} wird automatisch der Impfeintrag im e-Impfpass korrigiert.` +
                            ' Sind Sie sicher?',
                        'Bearbeiten',
                        'Abbrechen',
                    ).then(({ isConfirmed }: SweetAlertResult) => {
                        if (isConfirmed) {
                            this.editImpfung(impfung).then(afterEdit);
                        }
                    });
                } else {
                    this.editImpfung(impfung).then(afterEdit);
                }

                return;
            }

            if (!this.isHCWDisabled && this.data.hcw === 'n' && this.isNew && this.getSystemEinstellung('muw').isEnabled() &&
                (this.patientData.patientengruppe_id === Patgruppe.HCW_MUW || this.patientData.patientengruppe_id === Patgruppe.HCW_STUDENT)) {
                confirmSwal(
                    '',
                    'Ist Impfung HCW?',
                    'Ja',
                    'Nein')
                    .then(({isConfirmed}: SweetAlertResult) => {
                        if (isConfirmed) {
                            this.data.hcw = 'j';
                        }
                        this.createImpfung(this.data);
                    });
            } else {
                this.createImpfung(this.data);
            }
        }

        public onClickEdit(): void {
            this.isEditing = !this.isEditing;

            if (this.isEditing) {
                this.loadImpfstoffe({
                    chargen: false,
                    elgaimpfstoffe: true,
                    immunziationTarget: true,
                    impfschemen: true,
                    teilimpfungen: true,
                    nachtrag: false,
                });
                this.loadPersonen();
                this.loadImpfsettings();
            }
        }

        public onClickSaveAndNew(): void {
            this.validateImpfdatum();
            this.validateNaechstesImpfdatum();

            if (!this.$refs.form.validate() ||
                this.impfdatumErrorMessages.length > 0 ||
                this.naechstesImpfdatumErrorMessages.length > 0) {
                return;
            }

            if (!this.isHCWDisabled && this.data.hcw === 'n' && this.isNew && this.getSystemEinstellung('muw').isEnabled() &&
                (this.patientData.patientengruppe_id === Patgruppe.HCW_MUW || this.patientData.patientengruppe_id === Patgruppe.HCW_STUDENT)) {
                confirmSwal(
                    '',
                    'Ist Impfung HCW?',
                    'Ja',
                    'Nein')
                    .then(({isConfirmed}: SweetAlertResult) => {
                        if (isConfirmed) {
                            this.data.hcw = 'j';
                        }
                        this.createImpfungUndNeu({impfung: this.data, nachtrag: this.isNachtrag});
                    });
            } else {
                this.createImpfungUndNeu({impfung: this.data, nachtrag: this.isNachtrag});
            }
        }

        public onClickDelete(): void {
            if (this.data.abrechnung === Verrechnungsart.Bezahlt) {
                warningSwal(
                    'Fehler',
                    'Diese Impfung wurde bereits verrechnet! Bitte stornieren Sie die Rechnung zuerst.',
                    'Schließen',
                );
            } else {
                confirmSwal('Impfung löschen', 'Impfung wird gelöscht. Sind Sie sicher?', 'Löschen', ' Abbrechen')
                    .then(({isConfirmed}: SweetAlertResult) => {
                        if (isConfirmed) {
                            this.deleteImpfung();
                        }
                    });
            }
        }

        @Watch('data.seite_rechts')
        public changeOnSeiteRechts() {
            if (this.data.seite_rechts === 'j') {
                this.data.seite_links = null;
            } else if (this.data.seite_rechts === 'n') {
                this.data.seite_rechts = null;
            }
        }

        @Watch('data.seite_links')
        public changeOnSeiteLinks() {
            if (this.data.seite_links === 'j') {
                this.data.seite_rechts = null;
            } else if (this.data.seite_links === 'n') {
                this.data.seite_links = null;
            }
        }

        public isHCWEnabled() {
            if (this.data.nachtrag === 'j') {
                this.data.hcw = null;
                return;
            }
            if (this.data.impfstoff_id) {
                var impstoff = this.impfstoffe.find((impstoff: Impfstoffe) => impstoff.impfstoff_id === this.data.impfstoff_id);
                if (impstoff?.hcw === '1') {
                    if (this.isNew) {
                        this.data.hcw = 'j';
                    }
                } else if (impstoff?.hcw === '2') {
                    if (this.isNew) {
                        this.data.hcw = 'n';
                    }
                } else if (impstoff?.hcw === '0') {
                    this.data.hcw = 'n';
                } else {
                    this.data.hcw = null;
                }
            }
        }

        get isHCWDisabled(): boolean {
            if (this.data.nachtrag === 'j') {
                return true;
            }
            if (this.data.impfstoff_id) {
                var impstoff = this.impfstoffe.find((impstoff: Impfstoffe) => impstoff.impfstoff_id === this.data.impfstoff_id);
                if (impstoff?.hcw === '1') {
                    return false;
                } else if (impstoff?.hcw === '2') {
                    return false;
                } else if (impstoff?.hcw === '0') {
                    return true;
                } else {
                    return true;
                }
            }

            return true;
        }

        get filteredImpfaktionen() {
            const retval: any[] = [];

            _.forEach(this.impfaktionen, (impfaktion: Impfaktion) => {
                if (impfaktion.gueltig === 'j') {
                    retval.push(impfaktion);
                }
            });

            return retval;
        }
    }
